import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const homeServices = createApi({
  reducerPath: "home",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
  }),
  endpoints: (builder) => ({
    getHomeData: builder.query({
      query: () => ({
        url: "/api/home_data.php?uid=1",
        method: "GET",
      }),
      providesTags: ["homeOperation"],
    }),
  }),
  tagTypes: ["homeOperation"],
});

export const { useGetHomeDataQuery } = homeServices;

export default homeServices;
